import { giveawayEndpointIds } from 'root/src/shared/giveaways/giveaways.constants';
import { authenticationTypes, userGroups } from 'root/src/shared/constants/auth';
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
const getGiveawayEndpointPayloadSchema = {
    type: 'object',
    properties: {
        giveawayId: {
            type: 'string',
        },
    },
    required: ['giveawayId'],
};
export const getGiveawayEndpoint = {
    [giveawayEndpointIds.GET_GIVEAWAY]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.viewer,
        endpointType: otherEndpointType,
        payloadSchema: getGiveawayEndpointPayloadSchema,
    },
};
